module.exports = __webpack_public_path__ + "img/2.8a116f7a.jpg";